import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { revenueParametersReducer, modelActualReducer, modelInitialReducer, inputVariablesReducer, parametersVariablesUpdateReducer, resetOriginalValuesReducer, setActiveReducer } from './reducers/modelInputReaderReducer';
import { modelChangeReducer, modelUpdateReducer, setModifiedDateReducer } from './reducers/modelDetailsReducer';
import { userDataReducer, tabChangeReducer, setUserOnView } from './reducers/userDataReducer';
import { updateLookerFrameReducer, updateLookerTabsVisitedReducer, setAnalyticsLookerReducer, setRiskTypeReducer } from './reducers/lookerReducer';
import { modalOnOpenReducer, modalOnCloseReducer, modalETLHelpOnChangeReducer, modalHelpOnChangeReducer, modalAboutOnChangeReducer } from './reducers/modalOnChangeReducer';
import { uploadFilesChangeReducer, refreshJobListReducer } from './reducers/uploadFilesChangeReducer';

const middleware = [thunk];
const allReducers = combineReducers({
    modalOnOpenAction: modalOnOpenReducer,
    modalOnCloseAction: modalOnCloseReducer,
    modalHelpOnChange: modalHelpOnChangeReducer,
    modalETLHelpOnChange: modalETLHelpOnChangeReducer,
    modalAboutOnChange: modalAboutOnChangeReducer,
    userChangeAction: userDataReducer,
    getTabChangeAction: tabChangeReducer,
    getSelectedUser: setUserOnView,
    getActualAction: modelActualReducer,
    getActiveTab: setActiveReducer,
    getInitialAction: modelInitialReducer,
    revParamAction: revenueParametersReducer,
    inpVarblAction: inputVariablesReducer,
    modelChangeAction: modelChangeReducer,
    getModifiedDateAction: setModifiedDateReducer,
    paramsVariablesUpdated: parametersVariablesUpdateReducer,
    resetOriginalValuesFlag: resetOriginalValuesReducer,
    lookerParamsUpdated: updateLookerFrameReducer,
    getRiskType: setRiskTypeReducer,
    getAnalyticsLookerUrl: setAnalyticsLookerReducer,
    lookerTabsVisited : updateLookerTabsVisitedReducer,
    isModelUpdatedAction: modelUpdateReducer,
    uploadFilesAction: uploadFilesChangeReducer,
    refreshJobListAction: refreshJobListReducer
});

const initialState = {
    getActiveTab: undefined,
    getActualAction: undefined,
    getAnalyticsLookerUrl: undefined,
    getInitialAction: undefined,
    getModifiedDateAction: null,
    getRiskType: undefined,
    getSelectedUser: undefined,
    getTabChangeAction: undefined,
    inpVarblAction: null,
    isModelUpdatedAction: null,
    lookerParamsUpdated : {},
    lookerTabsVisited : {
        Addressable : false,
        InputVariables : false,
        RevenueByPayor : false,
        RevenueOpportunity : false,
        FiveYearRevenue : false,
    },
    modalAboutOnChange: undefined,
    modalETLHelpOnChange: undefined,
    modalHelpOnChange: undefined,
    modalOnCloseAction: undefined,
    modalOnOpenAction: undefined,
    modelChangeAction: null,
    paramsVariablesUpdated: { status: false },
    refreshJobListAction: null,
    resetOriginalValuesFlag: null,
    revParamAction: null,
    uploadFilesAction: undefined,
    userChangeAction: undefined,
};

const store = createStore(allReducers, initialState, compose(applyMiddleware(...middleware), (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) || compose));
export default store;
